import { render, staticRenderFns } from "./cmsres.vue?vue&type=template&id=15033bec"
import script from "./cmsres.vue?vue&type=script&lang=js"
export * from "./cmsres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports